exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dives-count[data-v-1b12f436]:first-letter{text-transform:uppercase}.discount-tag[data-v-1b12f436]{right:-2px}.btn-show-more[data-v-1b12f436]{width:200px;justify-content:center}@media(max-width:600px){.btn-show-more[data-v-1b12f436]{width:100%;justify-content:center}}.loader[data-v-1b12f436]{border:2px solid #dbdbdb;border-radius:50%;border-top:2px solid #1695a3;width:20px;height:20px;animation:spin-1b12f436 2s linear infinite}@-webkit-keyframes spin-1b12f436{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(1turn)}}@keyframes spin-1b12f436{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports
